import { render, staticRenderFns } from "./DiyPackage.vue?vue&type=template&id=141de859&scoped=true&"
import script from "./DiyPackage.vue?vue&type=script&lang=js&"
export * from "./DiyPackage.vue?vue&type=script&lang=js&"
import style0 from "./DiyPackage.vue?vue&type=style&index=0&id=141de859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141de859",
  null
  
)

export default component.exports